import React, {useEffect} from "react";
import {Dialog, DialogTitle, DialogContent, IconButton, Typography,  ListItem, ListItemText} from "@mui/material";
import CloseIcon from "../../../assets/icons/close.png";
import useAnomalyDetection from "../../../hooks/useAnomalyDetection";
import moment from "moment";

const AnomalyHistoryLogDetailViewDialog = (props) => {

    const {openHistoryLog, setOpenHistoryLog, anomalyId} = props;

    const {anomalyDetectionDetails, getAnomalyDetectionDetailView} = useAnomalyDetection();

    const handleCloseDialog = () => {
        setOpenHistoryLog(false);
    }

    useEffect(() => {
        getAnomalyDetectionDetailView(anomalyId);
    }, [anomalyId])


    return (
        <Dialog open={openHistoryLog} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{style: {borderRadius: "8px", padding: " 20px 24px"}, elevation: 24}}>
            <DialogTitle sx={{display: "flex"}}>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={{position: 'absolute', right: 36, top: 24}}
                >
                    <img alt="close-icon" src={CloseIcon} style={{height: 22}} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{padding: "20px 8px"}}>
                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Log ID: 
                            </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#58565f", fontSize: 16, fontWeight: "bold", ml: 1}}>
                                {anomalyDetectionDetails?.verification_id}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Hash Reference: 
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {anomalyDetectionDetails?.ovi}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Name:  
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {anomalyDetectionDetails?.product?.product_name}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Verification Method:
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                Mobile (static)
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Activity Type: 
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#3333CFF2", fontSize: 16, ml: 1}}>
                                Verification (static)
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Email Registry: 
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {anomalyDetectionDetails?.verificationLogs?.email}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Status: 
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{fontSize: 16, ml: "10px", color: 
                                (anomalyDetectionDetails?.status == "Suspicious") ? 
                                    "rgb(255, 165, 0)" 
                                : 
                                    "#E76C59"
                            }}>
                                {anomalyDetectionDetails?.status} (tentative)
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Location:   
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {anomalyDetectionDetails?.verificationLogs?.location}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Timestamp:   
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {moment(anomalyDetectionDetails?.timestamp).format('YYYY-MM-DD hh:mm:ss A')}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Details: 
                             </Typography>
                        } 
                        secondary={
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                N / A
                            </Typography>
                        }
                    />
                </ListItem>
            </DialogContent>
        </Dialog>
    )
}

export default AnomalyHistoryLogDetailViewDialog

